<!--<p-button size="small" (click)="op.show($event)" [label]="activeStatus?.name" [severity]="activeStatus?.severity" [rounded]="true"></p-button>-->
<split-status (click)="show($event)" [status]="activeStatus" [style]="style"></split-status>
<p-overlayPanel #op>
    <ul>
        <ng-container *ngFor="let status of listStatus; let i = index">
            <ng-container *ngIf="status.key != activeStatus">
             <li *ngIf="(filter.length <= 0 || filter.includes(status.key))" (click)="setActiveStatus(i)"><span class="split-legend" [ngClass]="status.severity"></span> {{status.name}}</li>
            </ng-container>
        </ng-container>
    </ul>
</p-overlayPanel>